import { el } from 'redom';

import TextInputRow from 'generics/components/text-input-row';

import OptionsEditor from '../base';
import RequiredInputRow from '../required-input-row';

class EmailFieldOptionsEditor extends OptionsEditor {

  constructor(configuration) {

    super(configuration);

    this.el = el('.text-field-options-editor-main', [
      this.renderPlaceholderInputRow(),
      this.renderRequiredAttributeInputRow()
    ]);

  }

  renderPlaceholderInputRow() {

    return new TextInputRow({
      label: 'Placeholder',
      placeholder: 'Placeholder text',
      value: this.fieldRow.options.placeholder,
      onChange: this.handlePlaceholderInputChange.bind(this)
    });

  }

  renderRequiredAttributeInputRow() {

    return new RequiredInputRow({
      checked: this.fieldRow.options.required,
      onChange: this.handleRequiredAttributeChange.bind(this)
    });

  }

  handlePlaceholderInputChange(event, placeholder) {

    this.fieldRow.options.placeholder = placeholder;

    this.propogateFieldOptionsChange();

  }

  handleRequiredAttributeChange(required) {

    this.fieldRow.options.required = required;

    this.propogateFieldOptionsChange();

  }

}

export default EmailFieldOptionsEditor;